// Mock data per la landing page Assietica

export const logoUrl = "https://customer-assets.emergentagent.com/job_consulenza-terzo/artifacts/ldtrfvrt_Assietica%20Soc.Coop.%20%282%29.png";

export const heroImages = [
  "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3NzE2ODc1MTd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1650978810505-12705ba70e6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjb29wZXJhdGlvbiUyMHBhcnRuZXJzaGlwfGVufDB8fHx8MTc3MTY4NzUyMXww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
];

export const benefitImages = [
  "https://images.unsplash.com/photo-1769740333462-9a63bfa914bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1lZXRpbmclMjBvZmZpY2UlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcyMTE2ODAwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1642522029686-5485ea7e6042?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjBvZmZpY2UlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcyMTE2ODAwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxzb2NpYWwlMjByZXNwb25zaWJpbGl0eXxlbnwwfHx8fDE3NzE2ODc1NjF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1527525443983-6e60c75fff46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxzb2NpYWwlMjByZXNwb25zaWJpbGl0eXxlbnwwfHx8fDE3NzE2ODc1NjF8MA&ixlib=rb-4.1.0&q=85"
];

export const problemi = [
  {
    icona: "ShieldAlert",
    titolo: "Polizze Generiche",
    descrizione: "Assicurazioni standard che non comprendono la specificità della vostra missione sociale, lasciando scoperti i rischi più importanti per chi opera nel Terzo Settore"
  },
  {
    icona: "Users",
    titolo: "Responsabilità CDA",
    descrizione: "Amministratori e dirigenti esposti personalmente: un rischio che può compromettere la continuità della missione e l'impatto sulla comunità che servite"
  },
  {
    icona: "Heart",
    titolo: "Rischi Volontari",
    descrizione: "Volontari e operatori sociali non adeguatamente protetti: chi dona il proprio tempo per la comunità merita una tutela all'altezza del suo impegno"
  },
  {
    icona: "FileCheck",
    titolo: "Conformità Normativa",
    descrizione: "La Riforma del Terzo Settore richiede adeguamenti specifici: la non conformità può mettere a rischio la vostra capacità di servire la comunità"
  },
  {
    icona: "AlertTriangle",
    titolo: "Scoperture Nascoste",
    descrizione: "Gap assicurativi che possono trasformarsi in emergenze. La Legge Gelli-Bianco espone ETS e Cooperative con attività sanitarie a rischi spesso sottovalutati"
  },
  {
    icona: "Building2",
    titolo: "Beni e Patrimonio",
    descrizione: "Il patrimonio dell'ente è lo strumento della vostra missione: proteggerlo significa garantire continuità all'impatto sociale che generate"
  }
];

export const benefici = [
  {
    icona: "Search",
    titolo: "Analisi Gratuita Coperture",
    descrizione: "Verifica approfondita delle tue polizze attuali senza impegno"
  },
  {
    icona: "CheckCircle2",
    titolo: "Verifica Conformità Normativa",
    descrizione: "Controllo dell'adeguamento alla Riforma del Terzo Settore"
  },
  {
    icona: "Shield",
    titolo: "Individuazione Rischi Scoperti",
    descrizione: "Identificazione di gap assicurativi e aree di vulnerabilità"
  },
  {
    icona: "FileText",
    titolo: "Proposta Personalizzata",
    descrizione: "Soluzione su misura per le esigenze specifiche del tuo ente"
  },
  {
    icona: "Headphones",
    titolo: "Supporto Gestione Sinistri",
    descrizione: "Assistenza dedicata in caso di necessità e gestione claim"
  }
];

export const percheSocietaBenefit = [
  {
    icona: "Target",
    titolo: "Finalità di Beneficio Comune",
    descrizione: "Agiamo per creare valore condiviso, non solo profitto"
  },
  {
    icona: "Users",
    titolo: "Impatto su Comunità",
    descrizione: "Contribuiamo attivamente allo sviluppo del territorio"
  },
  {
    icona: "Heart",
    titolo: "Centralità della Persona",
    descrizione: "Mettiamo al centro le persone, non solo i numeri"
  },
  {
    icona: "Eye",
    titolo: "Trasparenza",
    descrizione: "Operato chiaro e verificabile in ogni fase"
  },
  {
    icona: "Leaf",
    titolo: "Responsabilità Sociale",
    descrizione: "Impegno concreto per un futuro sostenibile"
  },
  {
    icona: "Handshake",
    titolo: "Etica Cooperativa",
    descrizione: "Coerenza tra valori assicurativi e principi mutualistici"
  }
];

export const tipiEnti = [
  "Cooperativa Sociale",
  "Associazione di Volontariato",
  "Organizzazione di Volontariato (ODV)",
  "Associazione di Promozione Sociale (APS)",
  "Fondazione",
  "Impresa Sociale",
  "Ente Filantropico",
  "ONLUS",
  "Altro"
];

// Mock function per simulare invio form
export const mockSubmitForm = async (formData) => {
  console.log("Mock: Form data inviato:", formData);
  
  // Simula un delay come una vera chiamata API
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Simula successo
  return {
    success: true,
    message: "Richiesta inviata con successo! Ti contatteremo presto."
  };
};
